var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swiper-container banner"},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.datas),function(item,index){return _c('div',{key:index,staticClass:"swiper-slide"},[_c('a',{attrs:{"href":item.url,"target":"_blank"}},[_c('img',{staticClass:"img",attrs:{"src":item.img}})])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37c5b117","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Swiper.vue
// module id = null
// module chunks = 